<template>
  <div class="logout">
    <el-divider content-position="left">工商注销进度</el-divider>
    <el-row>
      <el-col :span="4">
        <el-col :span="23">
          <el-select v-model="searchArr.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
            size="mini" clearable :remote-method="searchRemoteCompanyMethod" :loading="searchLoading"
            @change="handleSearchCompanyChange">
            <el-option v-for="searchCompany in searchCompanies" :key="searchCompany.id"
              :label="searchCompany.company_name" :value="searchCompany.id">
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="4">
        <el-col :span="23">
          <el-select v-model="searchArr.order_id" filterable remote clearable reserve-keyword placeholder="请输入订单编号"
            size="mini" @change="handleOrderChange" :remote-method="remoteMethod" :loading="loading">
            <el-option v-for="item in orderNums" :key="item.id" :label="item.order_num" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="4">
        <el-col :span="23">
          <el-select collapse-tags v-model="searchArr.status" placeholder="请选择办理完成状态" @change="handleOrderChange"
            size="mini" clearable>
            <el-option :value="1" label="未办理"></el-option>
            <el-option :value="2" label="办理中"></el-option>
            <el-option :value="3" label="已完成"></el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="2" style="margin-right: 5px">
        <el-popover placement="bottom-start" v-model="searchVisible" width="320">
          <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
            <el-col :span="6" style="margin-top: 0.1rem">服务状态：</el-col>
            <el-col :span="18">
              <el-select v-model="searchArr.service_status" placeholder="请选择" size="mini" clearable>
                <el-option :value="3" label="服务中"></el-option>
                <el-option :value="4" label="服务完成"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">沟通顾问：</el-col>
            <el-col :span="18">
              <el-cascader v-model="searchArr.consultant" placeholder="请选择沟通顾问" :options="users" size="mini"
                :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
              </el-cascader>

              <!-- <el-select
                v-model="searchArr.consultant"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
              >
                <el-option :value="null" label="NULL"></el-option>
                <el-option
                  v-for="option in users"
                  :key="option.id"
                  :label="option.username"
                  :value="option.id"
                >
                </el-option>
              </el-select> -->
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">行业特点：</el-col>
            <el-col :span="18">
              <el-select v-model="searchArr.feature" filterable placeholder="请选择" size="mini" clearable>
                <el-option v-for="item in features" :key="item.industry_id" :label="item.industry_name"
                  :value="item.industry_id"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">注册类型：</el-col>
            <el-col :span="18">
              <el-select v-model="searchArr.actual_reg_type" filterable placeholder="请选择" size="mini" clearable>
                <el-option v-for="item in regTypes" :key="item.reg_type_id" :label="item.reg_type_name"
                  :value="item.reg_type_id"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">服务人员：</el-col>
            <el-col :span="18">
              <el-cascader v-model="searchArr.operator" placeholder="请选择服务人员" :options="usersConvert" size="mini"
                :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
              </el-cascader>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">订单来源：</el-col>
            <el-col :span="18">
              <el-select v-model="searchArr.platform" filterable placeholder="请选择" clearable size="mini"
                @click.native="getFrom">
                <el-option v-for="item in fromOptions" :key="item.id" :value="item.id" :label="item.name">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">公司园区：</el-col>
            <el-col :span="18">
              <el-select v-model="searchArr.park" filterable placeholder="请选择" clearable size="mini">
                <el-option v-for="option in parks" :key="option.id" :label="option.areaName" :value="option.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
            <el-col :span="12" :offset="12">
              <el-button size="mini" @click="handleClearSearchGetData">清除</el-button>
              <el-button type="primary" @click="handleSearchGetData" size="mini">查询</el-button>
            </el-col>
          </el-row>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
    </el-row>
    <el-table height="calc(100vh - 276px)" :data="orders" size="medium" style="width: 100%; margin-top: 0.2rem" v-cloak
      border>
      <el-table-column label="订单编号" width="200" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.order_num" placement="top">
            <div class="company_hover">
              <span class="count_style" style="display: inherit">
                <el-link class="ellipsis-link" type="primary"
                  @click="handleOrderInfo(scope.row.id, scope.row.order_num)">{{ scope.row.order_num }}</el-link>
              </span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed label="服务状态" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.service_status === '服务中'">
            <span class="dot" style="background-color: #88d023"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
          <div v-else>
            <span class="dot" style="background-color: #ff8839"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="200">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.company ? scope.row.company : ''" placement="top">
            <el-link type="primary" class="count-style" @click="fhandleCompanyInfoOpen(scope.row.company_id)">{{
              scope.row.company ? scope.row.company : "" }}</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="单品名称" width="120">
        <template slot-scope="scope">
          <span class="count_style" style="display: inherit">{{
            scope.row.item_name ? scope.row.item_name : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="注销项目" width="120">
        <template slot-scope="scope">
          <span class="count_style" style="display: inherit">{{
            handleGetProjectName(scope.row.meal_singles)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单来源" width="100">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.platform }}</span>
        </template>
      </el-table-column>
      <el-table-column label="顾问">
        <template slot-scope="scope">
          <span class="hide-style">{{
            scope.row.advisor ? scope.row.advisor.username : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" width="110">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.customer_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户电话" width="170">
        <template slot-scope="scope">
          <!-- <span class="hide-style">{{ scope.row.customer_phone }}</span> -->
          <phone-com v-if="scope.row.customer_phone" :comPhone="scope.row.customer_phone"
            :vagaryPhone="scope.row.vagary_phone_custome" style="display: inline-block" />
        </template>
      </el-table-column>
      <el-table-column label="法人名称" width="110">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.corporate_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="法人电话" width="170">
        <template slot-scope="scope">
          <!-- <span class="hide-style">{{ scope.row.corporate_phone }}</span> -->
          <phone-com v-if="scope.row.corporate_phone" :comPhone="scope.row.corporate_phone"
            :vagaryPhone="scope.row.vagary_phone_corporate" style="display: inline-block" />
        </template>
      </el-table-column>
      <el-table-column label="工商注销人员" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_industry_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.industry_logout ? scope.row.industry_logout.admin.username : "未知"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工商注销状态" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_industry_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.industry_logout
              ? scope.row.industry_logout.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税务注销人员" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_tax_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.tax_logout ? scope.row.tax_logout.admin.username : "未知"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税务注销状态" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_tax_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.tax_logout
              ? scope.row.tax_logout.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="银行注销人员" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_bank_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.bank_logout ? scope.row.bank_logout.admin.username : "未知"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="银行注销状态" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_bank_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.bank_logout
              ? scope.row.bank_logout.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="社保注销人员" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_secuity_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.secuity_logout ? scope.row.secuity_logout.admin.username : "未知"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="社保注销状态" width="110">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_secuity_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.secuity_logout
              ? scope.row.secuity_logout.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公积金注销人员" width="120">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_accum_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.accum_logout ? scope.row.accum_logout.admin.username : "未知"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公积金注销状态" width="120">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_licence_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.licence_logout
              ? scope.row.licence_logout.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公积金注销状态" width="120">
        <template slot-scope="scope">
          <span class="hide-style" v-if="scope.row.meal_singles.indexOf('is_licence_logout') === -1">/</span>
          <span class="hide-style" v-else>{{
            scope.row.licence_logout
              ? scope.row.licence_logout.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="办理信息" placement="top">
            <el-button size="mini" icon="el-icon-edit-outline" type="info" circle
              @click="handleEditOpen(scope.$index, scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-phone-outline" circle
              @click="handCallLogsOpen(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
            <el-button type="warning" :disabled="scope.row.wx_work_chat_com ? false : true" @click="
              handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
              " size="mini" icon="el-icon-s-comment" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
      <el-pagination background class="pagination-style" layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize" :total="pageOption.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-drawer :title="'订单信息： ' + orderNum" :visible.sync="orderInfoVisible" direction="rtl" custom-class="AIdrawer"
      size="50%" :before-close="handleOrderInfoClose">
      <div class="drawer-title" slot="title">订单信息： {{ orderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" :checkType="serviceCheckType"></order-info>
      </div>
    </el-drawer>
    <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" direction="rtl"
      :before-close="handleCompanyInfoBeforeClose" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="电话联系记录" :visible.sync="callLogsDrawer" direction="rtl" :before-close="handleCallLogsBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs :company="company" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2"
            :phone3="callPhone3"></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer :title="'办理信息： ' + orderNum" :visible.sync="editDrawer" direction="rtl" custom-class="AIdrawer"
      :before-close="handleClearList" size="40%">
      <div class="drawer-title" slot="title">办理信息： {{ orderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <el-col :span="24">
            <el-col>
              <el-col :span="5"><span style="line-height: 28px">公司名称：</span></el-col>
              <el-col :span="16" v-if="companyName" style="line-height: 28px">{{
                companyName
                }}</el-col>
              <el-col :span="16" v-else>
                <el-select v-model="companyId" filterable remote reserve-keyword placeholder="请输入公司字号筛选公司" size="mini"
                  clearable @change="handleCompanyChange" :remote-method="remoteCompanyMethod" :loading="loading">
                  <el-option v-for="company in companies" :key="company.id" :label="company.company_name"
                    :value="company.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-col>
            <el-col :span="24">
              <span v-for="(card_item, index) in cards" :key="index">
                <el-tag style="margin: 10px 10px 0 0">{{
                  card_item === "is_industry_logout"
                    ? "工商注销"
                    : card_item === "is_tax_logout"
                      ? "税务注销"
                      : card_item === "is_bank_logout"
                        ? "银行注销"
                        : card_item === "is_secuity_logout"
                          ? "社保注销"
                          : card_item === "is_accum_logout"
                            ? "社保注销"
                            : "公积金注销"
                }}</el-tag>
              </span>
            </el-col>
          </el-col>
        </el-row>
        <el-row class="card-margin" v-for="(card_item, index) in cards" :key="index" v-if="companyName">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span v-if="card_item === 'is_industry_logout'">
                <span class="header-text">工商注销</span>
                <el-popconfirm title="确定工商注销完成吗？" @onConfirm="handleFinishedItem(card_item)">
                  <el-button style="float: right" slot="reference" type="success" size="mini"
                    :disabled="industryLogout.is_finish === 2">完成</el-button>
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_tax_logout'">
                <span class="header-text">税务注销</span>
                <el-popconfirm title="确定税务注销完成吗？" @onConfirm="handleFinishedItem(card_item)">
                  <el-button style="float: right" slot="reference" type="success" size="mini"
                    :disabled="taxLogout.is_finish === 2">完成</el-button>
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_bank_logout'">
                <span class="header-text">银行注销</span>
                <el-popconfirm title="确定银行注销完成吗？" @onConfirm="handleFinishedItem(card_item)">
                  <el-button style="float: right" slot="reference" type="success" size="mini"
                    :disabled="bankLogout.is_finish === 2">完成</el-button>
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_secuity_logout'">
                <span class="header-text">社保注销</span>
                <el-popconfirm title="确定社保注销完成吗？" @onConfirm="handleFinishedItem(card_item)">
                  <el-button style="float: right" slot="reference" type="success" size="mini"
                    :disabled="secuityLogout.is_finish === 2">完成</el-button>
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_accum_logout'">
                <span class="header-text">公积金注销</span>
                <el-popconfirm title="确定公积金注销完成吗？" @onConfirm="handleFinishedItem(card_item)">
                  <el-button style="float: right" slot="reference" type="success" size="mini"
                    :disabled="accumLogout.is_finish === 2">完成</el-button>
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_licence_logout'">
                <span class="header-text">许可证注销</span>
                <el-popconfirm title="确定许可证注销完成吗？" @onConfirm="handleFinishedItem(card_item)">
                  <el-button style="float: right" slot="reference" type="success" size="mini"
                    :disabled="licenceLogout.is_finish === 2">完成</el-button>
                </el-popconfirm>
              </span>
            </div>
            <el-col class="card-margin">
              <el-col :span="12">
                <el-col :span="10">&nbsp;操&nbsp;&nbsp;作&nbsp;&nbsp;人：</el-col>
                <el-col :span="14" v-if="card_item === 'is_industry_logout'">{{
                  industryLogout.handle ? industryLogout.handle : "无"
                  }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_tax_logout'">{{
                  taxLogout.handle ? taxLogout.handle : "无"
                  }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_bank_logout'">{{
                  bankLogout.handle ? bankLogout.handle : "无"
                  }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_secuity_logout'">{{
                  secuityLogout.handle ? secuityLogout.handle : "无"
                  }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_accum_logout'">{{
                  accumLogout.handle ? accumLogout.handle : "无"
                  }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_licence_logout'">{{
                  accumLogout.handle ? accumLogout.handle : "无"
                  }}</el-col>
              </el-col>
              <el-col :span="12">
                <el-col :span="8"> 操作时间：</el-col>
                <el-col :span="16" v-if="card_item === 'is_industry_logout'">{{
                  industryLogout.handle_at ? industryLogout.handle_at : "无"
                  }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_tax_logout'">{{
                  taxLogout.handle_at ? taxLogout.handle_at : "无"
                  }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_bank_logout'">{{
                  bankLogout.handle_at ? bankLogout.handle_at : "无"
                  }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_secuity_logout'">{{
                  secuityLogout.handle_at ? secuityLogout.handle_at : "无"
                  }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_accum_logout'">{{
                  accumLogout.handle_at ? accumLogout.handle_at : "无"
                  }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_licence_logout'">{{
                  accumLogout.handle_at ? accumLogout.handle_at : "无"
                  }}</el-col>
              </el-col>
            </el-col>
            <el-col>
              <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
                <el-col :span="24" class="card-margin">
                  <el-col style="margin-top: 0.2rem">
                    <el-card class="box-card">
                      <el-col :span="24" style="margin-bottom: 0.2rem">
                        <el-divider content-position="left">办理过程文件上传</el-divider>
                        <el-card shadow="hover">
                          <el-upload v-if="card_item === 'is_industry_logout'" multiple ref="upload" action="#"
                            :limit="5" :on-preview="handleLicensePreview" :on-change="handleLicenseChange6"
                            :on-remove="handleLicenseRemove6" :file-list="licenseList6"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 4)"
                              :disabled="industryLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_tax_logout'" multiple ref="upload" action="#" :limit="5"
                            :on-preview="handleLicensePreview" :on-change="handleLicenseChange7"
                            :on-remove="handleLicenseRemove7" :file-list="licenseList7"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 4)"
                              :disabled="taxLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_bank_logout'" multiple ref="upload" action="#" :limit="5"
                            :on-preview="handleLicensePreview" :on-change="handleLicenseChange8"
                            :on-remove="handleLicenseRemove8" :file-list="licenseList8"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件))</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 4)"
                              :disabled="bankLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_secuity_logout'" multiple ref="upload" action="#"
                            :limit="5" :on-preview="handleLicensePreview" :on-change="handleLicenseChange9"
                            :on-remove="handleLicenseRemove9" :file-list="licenseList9"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 4)"
                              :disabled="secuityLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_accum_logout'" multiple ref="upload" action="#" :limit="5"
                            :on-preview="handleLicensePreview" :on-change="handleLicenseChange10"
                            :on-remove="handleLicenseRemove10" :file-list="licenseList10"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 4)"
                              :disabled="accumLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_licence_logout'" multiple ref="upload" action="#"
                            :limit="5" :on-preview="handleLicensePreview" :on-change="handleLicenseChange11"
                            :on-remove="handleLicenseRemove11" :file-list="licenseList11"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 4)"
                              :disabled="licenceLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                        </el-card>
                      </el-col>
                      <el-input v-if="card_item === 'is_industry_logout'" v-paste="handleParse6" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_tax_logout'" v-paste="handleParse7" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_bank_logout'" v-paste="handleParse8" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_secuity_logout'" v-paste="handleParse9" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_accum_logout'" v-paste="handleParse10" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_licence_logout'" v-paste="handleParse11" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                    </el-card>
                  </el-col>
                  <el-col style="margin-top: 0.2rem">
                    <el-card class="box-card">
                      <el-col :span="24" style="margin-bottom: 0.2rem">
                        <el-divider content-position="left">办理完成文件上传</el-divider>
                        <el-card shadow="hover">
                          <el-upload v-if="card_item === 'is_industry_logout'" multiple ref="upload" action="#"
                            :limit="5" :on-preview="handleLicensePreview" :on-change="handleLicenseChange1"
                            :on-remove="handleLicenseRemove1" :file-list="licenseList1"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 5)"
                              :disabled="industryLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_tax_logout'" multiple ref="upload" action="#" :limit="5"
                            :on-preview="handleLicensePreview" :on-change="handleLicenseChange2"
                            :on-remove="handleLicenseRemove2" :file-list="licenseList2"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 5)"
                              :disabled="taxLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_bank_logout'" multiple ref="upload" action="#" :limit="5"
                            :on-preview="handleLicensePreview" :on-change="handleLicenseChange3"
                            :on-remove="handleLicenseRemove3" :file-list="licenseList3"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件))</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 5)"
                              :disabled="bankLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_secuity_logout'" multiple ref="upload" action="#"
                            :limit="5" :on-preview="handleLicensePreview" :on-change="handleLicenseChange4"
                            :on-remove="handleLicenseRemove4" :file-list="licenseList4"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 5)"
                              :disabled="secuityLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_accum_logout'" multiple ref="upload" action="#" :limit="5"
                            :on-preview="handleLicensePreview" :on-change="handleLicenseChange5"
                            :on-remove="handleLicenseRemove5" :file-list="licenseList5"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 5)"
                              :disabled="accumLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                          <el-upload v-if="card_item === 'is_licence_logout'" multiple ref="upload" action="#"
                            :limit="5" :on-preview="handleLicensePreview" :on-change="handleLicenseChange12"
                            :on-remove="handleLicenseRemove12" :file-list="licenseList12"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file" :auto-upload="false">
                            <el-link slot="trigger" type="primary" style="line-height: 28px">选择文件(最多可选择5个文件)</el-link>
                            <el-button type="primary" size="mini" style="float: right"
                              @click="submitAddUpload('addForm', card_item, 5)"
                              :disabled="licenceLogout.is_finish === 2">上传文件</el-button>
                          </el-upload>
                        </el-card>
                      </el-col>
                      <el-input v-if="card_item === 'is_industry_logout'" v-paste="handleParse1" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_tax_logout'" v-paste="handleParse2" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_bank_logout'" v-paste="handleParse3" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_secuity_logout'" v-paste="handleParse4" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_accum_logout'" v-paste="handleParse5" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                      <el-input v-if="card_item === 'is_licence_logout'" v-paste="handleParse12" type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图" />
                    </el-card>
                  </el-col>
                  <el-col> </el-col>
                </el-col>
              </el-form>
            </el-col>
            <el-col>
              <el-collapse v-model="collapseName1" v-if="card_item === 'is_industry_logout'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="industryLogout.images.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in industryLogout.images" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="industryLogout.images">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="industryLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="industryLogout.files.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in industryLogout.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <!-- <el-col :span="24" class="text-border" v-if="industryLogout.files[index].type === 4"> -->
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="industryLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="industryLogout.images2.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in industryLogout.images2" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="industryLogout.images2">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="industryLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="industryLogout.files2.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in industryLogout.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <!-- <el-col :span="24" class="text-border" v-if="industryLogout.files2[index].type === 5"> -->
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="industryLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName2" v-if="card_item === 'is_tax_logout'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="taxLogout.images.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in taxLogout.images" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="taxLogout.images">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="taxLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="taxLogout.files.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in taxLogout.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="taxLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="taxLogout.images2.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in taxLogout.images2" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="taxLogout.images2">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="taxLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="taxLogout.files2.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in taxLogout.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="taxLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName3" v-if="card_item === 'is_bank_logout'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="bankLogout.images.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in bankLogout.images" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="bankLogout.images">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="bankLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="bankLogout.files.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in bankLogout.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="bankLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="bankLogout.images2.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in bankLogout.images2" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="bankLogout.images2">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="bankLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="bankLogout.files2.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in bankLogout.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="bankLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName4" v-if="card_item === 'is_secuity_logout'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="secuityLogout.images.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in secuityLogout.images" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="secuityLogout.images">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="secuityLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="secuityLogout.files.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in secuityLogout.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="secuityLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="secuityLogout.images2.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in secuityLogout.images2" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="secuityLogout.images2">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="secuityLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="secuityLogout.files2.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in secuityLogout.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="secuityLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName5" v-if="card_item === 'is_accum_logout'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="accumLogout.images.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in accumLogout.images" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="accumLogout.images">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="accumLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="accumLogout.files.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in accumLogout.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="accumLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="accumLogout.images2.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in accumLogout.images2" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="accumLogout.images2">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="accumLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="accumLogout.files2.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in accumLogout.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="accumLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName6" v-if="card_item === 'is_licence_logout'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="licenceLogout.images.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in licenceLogout.images" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="licenceLogout.images">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="licenceLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="licenceLogout.files.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in licenceLogout.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="licenceLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider content-position="left" v-if="licenceLogout.images2.length > 0">图片编辑</el-divider>
                      <div style="float: left" v-for="(img, index) in licenceLogout.images2" :key="index">
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                            :preview-src-list="licenceLogout.images2">
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm title="确定要删除这张图片吗？" @onConfirm="handleDeleteImage(img, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="licenceLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="licenceLogout.files2.length > 0">文件编辑</el-divider>
                    <div v-for="(file, index) in licenceLogout.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                              }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"><el-button size="mini" type="success" plain
                            @click="downloadFile(file.file_url)">下载文件</el-button></el-col>
                        <el-col :span="4" :offset="1">
                          <el-popconfirm title="确定要删除这个文件吗？" @onConfirm="handleDeleteImage(file.file_url, card_item)">
                            <el-button slot="reference" size="mini" type="danger" plain
                              :disabled="licenceLogout.is_finish === 2">删除</el-button>
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
        </el-row>
        <el-row v-if="companyName">
          <el-popconfirm title="确认所有的变更都完成了吗？" @onConfirm="handleAllChangeOvered">
            <el-button style="float: right" slot="reference" size="mini" type="success"
              :disabled="isOvered">全部完成</el-button>
          </el-popconfirm>
        </el-row>
        <el-row style="height: 200px"></el-row>
      </div>
    </el-drawer>
    <el-drawer title="企业微信聊天记录" :visible.sync="wxChatDrawer" direction="rtl" :before-close="handleWxChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatCompany"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import CompanyInfo from "common/CompanyInfo";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";

export default {
  name: "Logout",
  components: {
    CallLogs,
    CompanyInfo,
    OrderInfo,
    WxWorkChat,
    PhoneCom
  },
  data() {
    return {
      wxChatDrawer: false,
      wxWorkChatId: "",
      serviceCheckType: this.$feedBackConfig.order_service,
      wxWorkchatCompany: "",
      orderNum: null,
      editDrawer: false,
      company: "",
      orderId: null,
      industry_type: null,
      tax_type: null,
      bank_type: null,
      secuity_type: null,
      accum_type: null,
      licence_type: null,
      companyId: null,
      companyName: "",
      isOvered: false,
      loading: false,
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      orders: [],
      cards: [],
      companies: [],
      collapseName1: [1],
      collapseName2: [1],
      collapseName3: [1],
      collapseName4: [1],
      collapseName5: [1],
      collapseName6: [1],
      licenseList1: [],
      licenseList2: [],
      licenseList3: [],
      licenseList4: [],
      licenseList5: [],
      licenseList6: [],
      licenseList7: [],
      licenseList8: [],
      licenseList9: [],
      licenseList10: [],
      licenseList11: [],
      licenseList12: [],
      searchArr: {
        order_id: null,
        status: null,
        service_status: "",
        consultant: "",
        feature: null,
        actual_reg_type: null,
        operator: "",
        platform: null,
        park: null,
      },
      addForm: {
        index: null,
        order_id: null,
        type: "",
      },
      industryLogout: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      taxLogout: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      bankLogout: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      secuityLogout: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      fromOptions: [],
      accumLogout: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      licenceLogout: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      orderRegs: [],
      meals: [],
      users: [],
      parks: [],
      regTypes: [],
      features: [],
      orderNums: [],
      searchVisible: false,
      callLogsDrawer: false,
      companyInfoDrawer: false,
      companyInfoId: null,
      orderInfoVisible: false,
      orderInfoId: null,
      searchLoading: false,
      searchCompanies: [],
      addtionData: { value: "自助下单", label: "自助下单" },
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    usersConvert() {
      return [this.addtionData, ...this.users];
    },
  },
  methods: {
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    getPageDatas() {
      this.$axios
        .get("/api/logout?page=" + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders = data.data.orders.data;
            this.orderRegs = data.data.orderRegs;
            this.meals = data.data.meals;
            this.users = data.data.users;
            this.parks = data.data.parks;
            this.regTypes = data.data.regTypes;
            this.features = data.data.features;
            this.pageOption.total = data.data.orders.total;
            for (let key in this.orders) {
              this.orders[key].item_name =
                this.orders[key].meal_singles.length > 0
                  ? this.orders[key].meal_singles[0].item_name
                  : "";
              if (this.orders[key].meal_singles.length > 0) {
                this.orders[key].meal_singles = this.getTypeArrIndex(
                  this.orders[key].meal_singles
                );
              } else {
                this.orders[key].meal_singles = [];
              }
            }
          }
        });
    },
    getTypeArrIndex(indexArr) {
      let arr = [];
      for (let key in indexArr[0]) {
        if (indexArr[0][key] === 2) {
          if (key === "item_id") {
            continue;
          }
          arr.push(key);
        }
      }
      return arr;
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        if (row.customer_phone) this.callPhone1.push(row.customer_phone);
        if (row.corporate_phone) this.callPhone2.push(row.corporate_phone);
        if (row.company_obj) {
          this.company = row.company_obj.company_name;
          if (row.company_obj.user) this.callPhone.push(row.company_obj.user.phone);
          if (row.company_obj.docking_phone)
            this.callPhone3.push(row.company_obj.docking_phone);
        }
      });
    },
    handleCompanyChange() {
      this.$axios
        .post("/api/industry/change/save_company/" + this.orderId, {
          cid: this.companyId,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.companyName = data.data.cname;
            this.orders[this.addForm.index].company_id = this.companyId;
            this.orders[this.addForm.index].company = data.data.cname;
            this.$message.success(data.msg);
          }
        });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchOrders(query);
        }, 200);
      } else {
        this.orderNums = [];
      }
    },
    searchOrders(query) {
      this.$axios.get("/api/admin/searchOrders?num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orderNums = data.data.orderNum;
        }
      });
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageDatas();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageDatas();
    },
    fhandleCompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    handleOrderInfo(orderId, order_num) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
        this.orderNum = order_num;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    handleGetProjectName(cards) {
      let arr = {
        is_industry_logout: "工商注销",
        is_tax_logout: "税务注销",
        is_bank_logout: "银行注销",
        is_secuity_logout: "社保注销",
        is_accum_logout: "公积金注销",
        is_licence_logout: "许可证注销",
      };
      let typeStr = "";
      for (var i = 0; i < cards.length; i++) {
        if (i === cards.length - 1) {
          typeStr += arr[cards[i]];
        } else {
          typeStr += arr[cards[i]] + " , ";
        }
      }
      return typeStr;
    },
    handleClearList() {
      this.editDrawer = false;
      this.licenseList1 = [];
      this.licenseList2 = [];
      this.licenseList3 = [];
      this.licenseList4 = [];
      this.licenseList5 = [];
      this.licenseList6 = [];
      this.licenseList7 = [];
      this.licenseList8 = [];
      this.licenseList9 = [];
      this.licenseList10 = [];
      this.industryLogout.id = null;
      this.industryLogout.type = "";
      this.industryLogout.handle = "";
      this.industryLogout.handle_at = "";
      this.industryLogout.is_finish = "";
      this.industryLogout.files = [];
      this.industryLogout.files2 = [];
      this.industryLogout.images = [];
      this.industryLogout.images2 = [];
      this.taxLogout.id = null;
      this.taxLogout.type = "";
      this.taxLogout.handle = "";
      this.taxLogout.handle_at = "";
      this.taxLogout.is_finish = "";
      this.taxLogout.files = [];
      this.taxLogout.files2 = [];
      this.taxLogout.images = [];
      this.taxLogout.images2 = [];
      this.bankLogout.id = null;
      this.bankLogout.type = "";
      this.bankLogout.handle = "";
      this.bankLogout.handle_at = "";
      this.bankLogout.is_finish = "";
      this.bankLogout.files = [];
      this.bankLogout.files2 = [];
      this.bankLogout.images = [];
      this.bankLogout.images2 = [];
      this.secuityLogout.id = null;
      this.secuityLogout.type = "";
      this.secuityLogout.handle = "";
      this.secuityLogout.handle_at = "";
      this.secuityLogout.is_finish = "";
      this.secuityLogout.files = [];
      this.secuityLogout.files2 = [];
      this.secuityLogout.images = [];
      this.secuityLogout.images2 = [];
      this.accumLogout.id = null;
      this.accumLogout.type = "";
      this.accumLogout.handle = "";
      this.accumLogout.handle_at = "";
      this.accumLogout.is_finish = "";
      this.accumLogout.files = [];
      this.accumLogout.files2 = [];
      this.accumLogout.images = [];
      this.accumLogout.images2 = [];
      this.licenceLogout.id = null;
      this.licenceLogout.type = "";
      this.licenceLogout.handle = "";
      this.licenceLogout.handle_at = "";
      this.licenceLogout.is_finish = "";
      this.licenceLogout.files = [];
      this.licenceLogout.files2 = [];
      this.licenceLogout.images = [];
      this.licenceLogout.images2 = [];
      this.addForm.index = null;
      this.addForm.order_id = null;
      this.addForm.type = "";
      this.industry_type = null;
      this.tax_type = null;
      this.bank_type = null;
      this.secuity_type = null;
      this.accum_type = null;
      this.companyId = null;
      this.companyName = "";
      this.isOvered = false;
      this.formData = null;
    },
    handleEditOpen(index, row) {
      this.cards = row.meal_singles;
      this.orderId = row.id;
      this.companyName = row.company;
      this.orderNum = row.order_num;
      this.addForm.index = index;
      if (row.is_overd) {
        this.isOvered = true;
      } else {
        this.isOvered = false;
      }
      if (row.industry_logout) {
        this.industryLogout.id = row.industry_logout.id;
        this.industryLogout.type = row.industry_logout.type;
        this.industryLogout.handle = row.industry_logout.admin.username;
        this.industryLogout.handle_at = row.industry_logout.handle_at;
        this.industryLogout.is_finish = row.industry_logout.is_finish;
        if (row.industry_logout.files.length > 0) {
          for (let key in row.industry_logout.files) {
            if (row.industry_logout.files[key].type === 4) {
              this.industryLogout.files.push(row.industry_logout.files[key]);
            } else {
              this.industryLogout.files2.push(row.industry_logout.files[key]);
            }
          }
        }
        if (row.industry_logout.images.length > 0) {
          for (let key in row.industry_logout.images) {
            if (row.industry_logout.images[key].type === 4) {
              this.industryLogout.images.push(row.industry_logout.images[key].image_url);
            } else {
              this.industryLogout.images2.push(row.industry_logout.images[key].image_url);
            }
          }
        }
      }
      if (row.tax_logout) {
        this.taxLogout.id = row.tax_logout.id;
        this.taxLogout.type = row.tax_logout.type;
        this.taxLogout.handle = row.tax_logout.admin.username;
        this.taxLogout.handle_at = row.tax_logout.handle_at;
        this.taxLogout.is_finish = row.tax_logout.is_finish;
        if (row.industry_logout.files.length > 0) {
          for (let key in row.tax_logout.files) {
            if (row.tax_logout.files[key].type === 4) {
              this.taxLogout.files.push(row.tax_logout.files[key]);
            } else {
              this.taxLogout.files2.push(row.tax_logout.files[key]);
            }
          }
        }
        if (row.tax_logout.images.length > 0) {
          for (let key in row.tax_logout.images) {
            if (row.tax_logout.images[key].type === 4) {
              this.taxLogout.images.push(row.tax_logout.images[key].image_url);
            } else {
              this.taxLogout.images2.push(row.tax_logout.images[key].image_url);
            }
          }
        }
      }
      if (row.bank_logout) {
        this.bankLogout.id = row.bank_logout.id;
        this.bankLogout.type = row.bank_logout.type;
        this.bankLogout.handle = row.bank_logout.admin.username;
        this.bankLogout.handle_at = row.bank_logout.handle_at;
        this.bankLogout.is_finish = row.bank_logout.is_finish;
        if (row.bank_logout.files.length > 0) {
          for (let key in row.bank_logout.files) {
            if (row.bank_logout.files[key].type === 4) {
              this.bankLogout.files.push(row.bank_logout.files[key]);
            } else {
              this.bankLogout.files2.push(row.bank_logout.files[key]);
            }
          }
        }
        if (row.bank_logout.images.length > 0) {
          for (let key in row.bank_logout.images) {
            if (row.bank_logout.images[key].type === 4) {
              this.bankLogout.images.push(row.bank_logout.images[key].image_url);
            } else {
              this.bankLogout.images2.push(row.bank_logout.images[key].image_url);
            }
          }
        }
      }
      if (row.secuity_logout) {
        this.secuityLogout.id = row.secuity_logout.id;
        this.secuityLogout.type = row.secuity_logout.type;
        this.secuityLogout.handle = row.secuity_logout.admin.username;
        this.secuityLogout.handle_at = row.secuity_logout.handle_at;
        this.secuityLogout.is_finish = row.secuity_logout.is_finish;
        if (row.secuity_logout.files.length > 0) {
          for (let key in row.secuity_logout.files) {
            if (row.secuity_logout.files[key].type === 4) {
              this.secuityLogout.files.push(row.secuity_logout.files[key]);
            } else {
              this.secuityLogout.files2.push(row.secuity_logout.files[key]);
            }
          }
        }
        if (row.secuity_logout.images.length > 0) {
          for (let key in row.secuity_logout.images) {
            if (row.secuity_logout.images[key].type === 4) {
              this.secuityLogout.images.push(row.secuity_logout.images[key].image_url);
            } else {
              this.secuityLogout.images2.push(row.secuity_logout.images[key].image_url);
            }
          }
        }
      }
      if (row.accum_logout) {
        this.accumLogout.id = row.accum_logout.id;
        this.accumLogout.type = row.accum_logout.type;
        this.accumLogout.handle = row.accum_logout.admin.username;
        this.accumLogout.handle_at = row.accum_logout.handle_at;
        this.accumLogout.is_finish = row.accum_logout.is_finish;
        if (row.accum_logout.files.length > 0) {
          for (let key in row.accum_logout.files) {
            if (row.accum_logout.files[key].type === 4) {
              this.accumLogout.files.push(row.accum_logout.files[key]);
            } else {
              this.accumLogout.files2.push(row.accum_logout.files[key]);
            }
          }
        }
        if (row.accum_logout.images.length > 0) {
          for (let key in row.accum_logout.images) {
            if (row.accum_logout.images[key].type === 4) {
              this.accumLogout.images.push(row.accum_logout.images[key].image_url);
            } else {
              this.accumLogout.images2.push(row.accum_logout.images[key].image_url);
            }
          }
        }
      }
      if (row.licence_logout) {
        this.licenceLogout.id = row.licence_logout.id;
        this.licenceLogout.type = row.licence_logout.type;
        this.licenceLogout.handle = row.licence_logout.admin.username;
        this.licenceLogout.handle_at = row.licence_logout.handle_at;
        this.licenceLogout.is_finish = row.licence_logout.is_finish;
        if (row.licence_logout.files.length > 0) {
          for (let key in row.licence_logout.files) {
            if (row.licence_logout.files[key].type === 4) {
              this.licenceLogout.files.push(row.licence_logout.files[key]);
            } else {
              this.licenceLogout.files2.push(row.licence_logout.files[key]);
            }
          }
        }
        if (row.licence_logout.images.length > 0) {
          for (let key in row.licence_logout.images) {
            if (row.licence_logout.images[key].type === 4) {
              this.licenceLogout.images.push(row.licence_logout.images[key].image_url);
            } else {
              this.licenceLogout.images2.push(row.licence_logout.images[key].image_url);
            }
          }
        }
      }
      this.editDrawer = true;
    },
    submitAddUpload(formName, cardItem, isOver) {
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          this.formData = new FormData();
          if (isOver === 5) {
            if (cardItem === "is_industry_logout") {
              if (this.licenseList1.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList1.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_tax_logout") {
              if (this.licenseList2.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList2.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_bank_logout") {
              if (this.licenseList3.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList3.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_secuity_logout") {
              if (this.licenseList4.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList4.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_accum_logout") {
              if (this.licenseList5.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList5.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_licence_logout") {
              if (this.licenseList12.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList12.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
          } else {
            if (cardItem === "is_industry_logout") {
              if (this.licenseList6.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList6.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_tax_logout") {
              if (this.licenseList7.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList7.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_bank_logout") {
              if (this.licenseList8.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList8.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_secuity_logout") {
              if (this.licenseList9.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList9.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_accum_logout") {
              if (this.licenseList10.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList10.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_licence_logout") {
              if (this.licenseList11.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList11.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
          }
          this.addForm.type = cardItem;
          this.addForm.order_id = this.orderId;
          this.addForm.is_over = isOver;
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key]);
          }
          this.$axios.post("/api/logout/upload", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              if (cardItem === "is_industry_logout") {
                this.industry_type = null;
                this.orders[this.addForm.index].industry_logout = data.data.logout;
                this.industryLogout.id = data.data.logout.id;
                this.industryLogout.handle = data.data.logout.admin.username;
                this.industryLogout.handle_at = data.data.logout.handle_at;
                this.industryLogout.is_finish = data.data.logout.is_finish;
                if (data.data.logout.images.length > 0) {
                  this.industryLogout.images = [];
                  this.industryLogout.images2 = [];
                  this.industryLogout.files = [];
                  this.industryLogout.files2 = [];
                  for (let key in data.data.logout.images) {
                    if (data.data.logout.images[key].type === 4) {
                      this.industryLogout.images.push(
                        data.data.logout.images[key].image_url
                      );
                    } else {
                      this.industryLogout.images2.push(
                        data.data.logout.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.logout.files.length > 0) {
                  this.industryLogout.files = [];
                  this.industryLogout.files2 = [];
                  for (let key in data.data.logout.files) {
                    if (data.data.logout.files[key].type === 4) {
                      this.industryLogout.files.push(data.data.logout.files[key]);
                    } else {
                      this.industryLogout.files2.push(data.data.logout.files[key]);
                    }
                  }
                }
                this.licenseList1 = [];
                this.licenseList6 = [];
              }
              if (cardItem === "is_tax_logout") {
                this.tax_type = null;
                this.orders[this.addForm.index].tax_logout = data.data.logout;
                this.taxLogout.id = data.data.logout.id;
                this.taxLogout.is_finish = data.data.logout.is_finish;
                this.taxLogout.handle = data.data.logout.admin.username;
                this.taxLogout.handle_at = data.data.logout.handle_at;
                if (data.data.logout.images.length > 0) {
                  this.taxLogout.images = [];
                  this.taxLogout.images2 = [];
                  for (let key in data.data.logout.images) {
                    if (data.data.logout.images[key].type === 4) {
                      this.taxLogout.images.push(data.data.logout.images[key].image_url);
                    } else {
                      this.taxLogout.images2.push(data.data.logout.images[key].image_url);
                    }
                  }
                }
                if (data.data.logout.files.length > 0) {
                  this.taxLogout.files = [];
                  this.taxLogout.files2 = [];
                  for (let key in data.data.logout.files) {
                    if (data.data.logout.files[key].type === 4) {
                      this.taxLogout.files.push(data.data.logout.files[key]);
                    } else {
                      this.taxLogout.files2.push(data.data.logout.files[key]);
                    }
                  }
                }
                this.licenseList2 = [];
                this.licenseList7 = [];
              }
              if (cardItem === "is_bank_logout") {
                this.bank_type = null;
                this.orders[this.addForm.index].bank_logout = data.data.logout;
                this.bankLogout.id = data.data.logout.id;
                this.bankLogout.is_finish = data.data.logout.is_finish;
                this.bankLogout.handle = data.data.logout.admin.username;
                this.bankLogout.handle_at = data.data.logout.handle_at;
                if (data.data.logout.images.length > 0) {
                  this.bankLogout.images = [];
                  this.bankLogout.images2 = [];
                  for (let key in data.data.logout.images) {
                    if (data.data.logout.images[key].type === 4) {
                      this.bankLogout.images.push(data.data.logout.images[key].image_url);
                    } else {
                      this.bankLogout.images2.push(
                        data.data.logout.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.logout.files.length > 0) {
                  this.bankLogout.files = [];
                  this.bankLogout.files2 = [];
                  for (let key in data.data.logout.files) {
                    if (data.data.logout.files[key].type === 4) {
                      this.bankLogout.files.push(data.data.logout.files[key]);
                    } else {
                      this.bankLogout.files2.push(data.data.logout.files[key]);
                    }
                  }
                }
                this.licenseList3 = [];
                this.licenseList8 = [];
              }
              if (cardItem === "is_secuity_logout") {
                this.secuity_type = null;
                this.orders[this.addForm.index].secuity_logout = data.data.logout;
                this.secuityLogout.id = data.data.logout.id;
                this.secuityLogout.is_finish = data.data.logout.is_finish;
                this.secuityLogout.handle = data.data.logout.admin.username;
                this.secuityLogout.handle_at = data.data.logout.handle_at;
                if (data.data.logout.images.length > 0) {
                  this.secuityLogout.images = [];
                  this.secuityLogout.images2 = [];
                  for (let key in data.data.logout.images) {
                    if (data.data.logout.images[key].type === 4) {
                      this.secuityLogout.images.push(
                        data.data.logout.images[key].image_url
                      );
                    } else {
                      this.secuityLogout.images2.push(
                        data.data.logout.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.logout.files.length > 0) {
                  this.secuityLogout.files = [];
                  this.secuityLogout.files2 = [];
                  for (let key in data.data.logout.files) {
                    if (data.data.logout.files[key].type === 4) {
                      this.secuityLogout.files.push(data.data.logout.files[key]);
                    } else {
                      this.secuityLogout.files2.push(data.data.logout.files[key]);
                    }
                  }
                }
                this.licenseList4 = [];
                this.licenseList9 = [];
              }
              if (cardItem === "is_accum_logout") {
                this.accum_type = null;
                this.orders[this.addForm.index].accum_logout = data.data.logout;
                this.accumLogout.id = data.data.logout.id;
                this.accumLogout.is_finish = data.data.logout.is_finish;
                this.accumLogout.handle = data.data.logout.admin.username;
                this.accumLogout.handle_at = data.data.logout.handle_at;
                if (data.data.logout.images.length > 0) {
                  this.accumLogout.images = [];
                  this.accumLogout.images2 = [];
                  for (let key in data.data.logout.images) {
                    if (data.data.logout.images[key].type === 4) {
                      this.accumLogout.images.push(
                        data.data.logout.images[key].image_url
                      );
                    } else {
                      this.accumLogout.images2.push(
                        data.data.logout.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.logout.files.length > 0) {
                  this.accumLogout.files = [];
                  this.accumLogout.files2 = [];
                  for (let key in data.data.logout.files) {
                    if (data.data.logout.files[key].type === 4) {
                      this.accumLogout.files.push(data.data.logout.files[key]);
                    } else {
                      this.accumLogout.files2.push(data.data.logout.files[key]);
                    }
                  }
                }
                this.licenseList5 = [];
                this.licenseList10 = [];
              }
              if (cardItem === "is_licence_logout") {
                this.licence_type = null;
                this.orders[this.addForm.index].licence_logout = data.data.logout;
                this.licenceLogout.id = data.data.logout.id;
                this.licenceLogout.is_finish = data.data.logout.is_finish;
                this.licenceLogout.handle = data.data.logout.admin.username;
                this.licenceLogout.handle_at = data.data.logout.handle_at;
                if (data.data.logout.images.length > 0) {
                  this.licenceLogout.images = [];
                  this.licenceLogout.images2 = [];
                  for (let key in data.data.logout.images) {
                    if (data.data.logout.images[key].type === 4) {
                      this.licenceLogout.images.push(
                        data.data.logout.images[key].image_url
                      );
                    } else {
                      this.licenceLogout.images2.push(
                        data.data.logout.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.logout.files.length > 0) {
                  this.licenceLogout.files = [];
                  this.licenceLogout.files2 = [];
                  for (let key in data.data.logout.files) {
                    if (data.data.logout.files[key].type === 4) {
                      this.licenceLogout.files.push(data.data.logout.files[key]);
                    } else {
                      this.licenceLogout.files2.push(data.data.logout.files[key]);
                    }
                  }
                }
                this.licenseList11 = [];
                this.licenseList12 = [];
              }
              this.formData = null;
              this.$refs["addForm"][0].resetFields();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleLicensePreview(file) { },
    handleLicenseChange1(file, fileList) {
      this.licenseList1 = fileList;
    },
    handleLicenseChange2(file, fileList) {
      this.licenseList2 = fileList;
    },
    handleLicenseChange3(file, fileList) {
      this.licenseList3 = fileList;
    },
    handleLicenseChange4(file, fileList) {
      this.licenseList4 = fileList;
    },
    handleLicenseChange5(file, fileList) {
      this.licenseList5 = fileList;
    },
    handleLicenseChange6(file, fileList) {
      this.licenseList6 = fileList;
    },
    handleLicenseChange7(file, fileList) {
      this.licenseList7 = fileList;
    },
    handleLicenseChange8(file, fileList) {
      this.licenseList8 = fileList;
    },
    handleLicenseChange9(file, fileList) {
      this.licenseList9 = fileList;
    },
    handleLicenseChange10(file, fileList) {
      this.licenseList10 = fileList;
    },
    handleLicenseChange11(file, fileList) {
      this.licenseList11 = fileList;
    },
    handleLicenseChange12(file, fileList) {
      this.licenseList12 = fileList;
    },
    handleLicenseRemove1(file, fileList) {
      this.licenseList1 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList1.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove2(file, fileList) {
      this.licenseList2 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList2.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove3(file, fileList) {
      this.licenseList3 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList3.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove4(file, fileList) {
      this.licenseList4 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList4.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove5(file, fileList) {
      this.licenseList5 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList5.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove6(file, fileList) {
      this.licenseList6 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList6.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove7(file, fileList) {
      this.licenseList7 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList7.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove8(file, fileList) {
      this.licenseList8 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList8.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove9(file, fileList) {
      this.licenseList9 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList9.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove10(file, fileList) {
      this.licenseList10 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList10.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove11(file, fileList) {
      this.licenseList11 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList11.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove12(file, fileList) {
      this.licenseList12 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList12.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse1(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList1.length < 5) {
            that.licenseList1.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse2(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList2.length < 5) {
            that.licenseList2.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse3(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList3.length < 5) {
            that.licenseList3.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse4(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList4.length < 5) {
            that.licenseList4.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse5(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList5.length < 5) {
            that.licenseList5.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse6(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList6.length < 5) {
            that.licenseList6.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse7(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList7.length < 5) {
            that.licenseList7.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse8(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList8.length < 5) {
            that.licenseList8.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse9(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList9.length < 5) {
            that.licenseList9.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse10(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList10.length < 5) {
            that.licenseList10.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse11(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList11.length < 5) {
            that.licenseList11.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse12(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList12.length < 5) {
            that.licenseList12.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleAllChangeOvered() {
      this.$axios.post("/api/logout/overed/" + this.orderId).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.isOvered = true;
          this.orders[this.addForm.index].is_overd = data.data.logout;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleFinishedItem(cardItem) {
      let recordId = null;
      if (cardItem === "is_industry_logout") {
        recordId = this.industryLogout.id;
      }
      if (cardItem === "is_tax_logout") {
        recordId = this.taxLogout.id;
      }
      if (cardItem === "is_bank_logout") {
        recordId = this.bankLogout.id;
      }
      if (cardItem === "is_secuity_logout") {
        recordId = this.secuityLogout.id;
      }
      if (cardItem === "is_accum_logout") {
        recordId = this.accumLogout.id;
      }
      if (cardItem === "is_licence_logout") {
        recordId = this.licenceLogout.id;
      }
      if (!recordId) {
        this.$message.error("请上传变更所需的文件后再确认完成！");
        return false;
      }
      this.$axios.post("/api/logout/fished/" + recordId).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          if (cardItem === "is_industry_logout") {
            this.orders[this.addForm.index].industry_logout = data.data.logout;
            this.industryLogout.handle = data.data.logout.admin.username;
            this.industryLogout.handle_at = data.data.logout.handle_at;
            this.industryLogout.is_finish = data.data.logout.is_finish;
          }
          if (cardItem === "is_tax_logout") {
            this.orders[this.addForm.index].tax_logout = data.data.logout;
            this.taxLogout.handle = data.data.logout.admin.username;
            this.taxLogout.handle_at = data.data.logout.handle_at;
            this.taxLogout.is_finish = data.data.logout.is_finish;
          }
          if (cardItem === "is_bank_logout") {
            this.orders[this.addForm.index].bank_logout = data.data.logout;
            this.bankLogout.handle = data.data.logout.admin.username;
            this.bankLogout.handle_at = data.data.logout.handle_at;
            this.bankLogout.is_finish = data.data.logout.is_finish;
          }
          if (cardItem === "is_secuity_logout") {
            this.orders[this.addForm.index].secuity_logout = data.data.logout;
            this.secuityLogout.handle = data.data.logout.admin.username;
            this.secuityLogout.handle_at = data.data.logout.handle_at;
            this.secuityLogout.is_finish = data.data.logout.is_finish;
          }
          if (cardItem === "is_accum_logout") {
            this.orders[this.addForm.index].accum_logout = data.data.logout;
            this.accumLogout.handle = data.data.logout.admin.username;
            this.accumLogout.handle_at = data.data.logout.handle_at;
            this.accumLogout.is_finish = data.data.logout.is_finish;
          }
          if (cardItem === "is_licence_logout") {
            this.orders[this.addForm.index].licence_logout = data.data.logout;
            this.licenceLogout.handle = data.data.logout.admin.username;
            this.licenceLogout.handle_at = data.data.logout.handle_at;
            this.licenceLogout.is_finish = data.data.logout.is_finish;
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    downloadFile(url) {
      window.open(url);
    },
    handleDeleteImage(img, cardItem) {
      let recordId = null;
      if (cardItem === "is_industry_logout") {
        recordId = this.industryLogout.id;
      }
      if (cardItem === "is_tax_logout") {
        recordId = this.taxLogout.id;
      }
      if (cardItem === "is_bank_logout") {
        recordId = this.bankLogout.id;
      }
      if (cardItem === "is_secuity_logout") {
        recordId = this.secuityLogout.id;
      }
      if (cardItem === "is_accum_logout") {
        recordId = this.accumLogout.id;
      }
      if (cardItem === "is_licence_logout") {
        recordId = this.licenceLogout.id;
      }
      this.$axios
        .post("/api/logout/delete", { path: img, record_id: recordId })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            if (cardItem === "is_industry_logout") {
              this.orders[this.addForm.index].industry_logout = data.data.logout;
              this.industryLogout.handle = data.data.logout.admin.username;
              this.industryLogout.handle_at = data.data.logout.handle_at;
              if (data.data.logout.files.length > 0) {
                this.industryLogout.files = [];
                this.industryLogout.files2 = [];
                for (let key in data.data.logout.files) {
                  if (data.data.logout.files[key].type === 4) {
                    this.industryLogout.files.push(data.data.logout.files[key]);
                  } else {
                    this.industryLogout.files2.push(data.data.logout.files[key]);
                  }
                }
              }
              if (data.data.logout.images.length > 0) {
                this.industryLogout.images = [];
                this.industryLogout.images2 = [];
                for (let key in data.data.logout.images) {
                  if (data.data.logout.images[key].type === 4) {
                    this.industryLogout.images.push(
                      data.data.logout.images[key].image_url
                    );
                  } else {
                    this.industryLogout.images2.push(
                      data.data.logout.images[key].image_url
                    );
                  }
                }
              }
            }
            if (cardItem === "is_tax_logout") {
              this.orders[this.addForm.index].tax_logout = data.data.logout;
              this.taxLogout.handle = data.data.logout.admin.username;
              this.taxLogout.handle_at = data.data.logout.handle_at;
              if (data.data.logout.files.length > 0) {
                this.taxLogout.files = [];
                this.taxLogout.files2 = [];
                for (let key in data.data.logout.files) {
                  if (data.data.logout.files[key].type === 4) {
                    this.taxLogout.files.push(data.data.logout.files[key]);
                  } else {
                    this.taxLogout.files2.push(data.data.logout.files[key]);
                  }
                }
              }
              if (data.data.logout.images.length > 0) {
                this.taxLogout.images = [];
                this.taxLogout.images2 = [];
                for (let key in data.data.logout.images) {
                  if (data.data.logout.images[key].type === 4) {
                    this.taxLogout.images.push(data.data.logout.images[key].image_url);
                  } else {
                    this.taxLogout.images2.push(data.data.logout.images[key].image_url);
                  }
                }
              }
            }
            if (cardItem === "is_bank_logout") {
              this.orders[this.addForm.index].bank_logout = data.data.logout;
              this.bankLogout.handle = data.data.logout.admin.username;
              this.bankLogout.handle_at = data.data.logout.handle_at;
              if (data.data.logout.files.length > 0) {
                this.bankLogout.files = [];
                this.bankLogout.files2 = [];
                for (let key in data.data.logout.files) {
                  if (data.data.logout.files[key].type === 4) {
                    this.bankLogout.files.push(data.data.logout.files[key]);
                  } else {
                    this.bankLogout.files2.push(data.data.logout.files[key]);
                  }
                }
              }
              if (data.data.logout.images.length > 0) {
                this.bankLogout.images = [];
                this.bankLogout.images2 = [];
                for (let key in data.data.logout.images) {
                  if (data.data.logout.images[key].type === 4) {
                    this.bankLogout.images.push(data.data.logout.images[key].image_url);
                  } else {
                    this.bankLogout.images2.push(data.data.logout.images[key].image_url);
                  }
                }
              }
            }
            if (cardItem === "is_secuity_logout") {
              this.orders[this.addForm.index].secuity_logout = data.data.logout;
              this.secuityLogout.handle = data.data.logout.admin.username;
              this.secuityLogout.handle_at = data.data.logout.handle_at;
              if (data.data.logout.files.length > 0) {
                this.secuityLogout.files = [];
                this.secuityLogout.files2 = [];
                for (let key in data.data.logout.files) {
                  if (data.data.logout.files[key].type === 4) {
                    this.secuityLogout.files.push(data.data.logout.files[key]);
                  } else {
                    this.secuityLogout.files2.push(data.data.logout.files[key]);
                  }
                }
              }
              if (data.data.logout.images.length > 0) {
                this.secuityLogout.images = [];
                this.secuityLogout.images2 = [];
                for (let key in data.data.logout.images) {
                  if (data.data.logout.images[key].type === 4) {
                    this.secuityLogout.images.push(
                      data.data.logout.images[key].image_url
                    );
                  } else {
                    this.secuityLogout.images2.push(
                      data.data.logout.images[key].image_url
                    );
                  }
                }
              }
            }
            if (cardItem === "is_accum_logout") {
              this.orders[this.addForm.index].accum_logout = data.data.logout;
              this.accumLogout.handle = data.data.logout.admin.username;
              this.accumLogout.handle_at = data.data.logout.handle_at;
              if (data.data.logout.files.length > 0) {
                this.accumLogout.files = [];
                this.accumLogout.files2 = [];
                for (let key in data.data.logout.files) {
                  if (data.data.logout.files[key].type === 4) {
                    this.accumLogout.files.push(data.data.logout.files[key]);
                  } else {
                    this.accumLogout.files2.push(data.data.logout.files[key]);
                  }
                }
              }
              if (data.data.logout.images.length > 0) {
                this.accumLogout.images = [];
                this.accumLogout.images2 = [];
                for (let key in data.data.logout.images) {
                  if (data.data.logout.images[key].type === 4) {
                    this.accumLogout.images.push(data.data.logout.images[key].image_url);
                  } else {
                    this.accumLogout.images2.push(data.data.logout.images[key].image_url);
                  }
                }
              }
            }
            if (cardItem === "is_licence_logout") {
              this.orders[this.addForm.index].licence_logout = data.data.logout;
              this.licenceLogout.handle = data.data.logout.admin.username;
              this.licenceLogout.handle_at = data.data.logout.handle_at;
              if (data.data.logout.files.length > 0) {
                this.licenceLogout.files = [];
                this.licenceLogout.files2 = [];
                for (let key in data.data.logout.files) {
                  if (data.data.logout.files[key].type === 4) {
                    this.licenceLogout.files.push(data.data.logout.files[key]);
                  } else {
                    this.licenceLogout.files2.push(data.data.logout.files[key]);
                  }
                }
              }
              if (data.data.logout.images.length > 0) {
                this.licenceLogout.images = [];
                this.licenceLogout.images2 = [];
                for (let key in data.data.logout.images) {
                  if (data.data.logout.images[key].type === 4) {
                    this.licenceLogout.images.push(
                      data.data.logout.images[key].image_url
                    );
                  } else {
                    this.licenceLogout.images2.push(
                      data.data.logout.images[key].image_url
                    );
                  }
                }
              }
            }
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleOrderChange() {
      this.pageOption.currentPage = 1;
      this.getPageDatas();
    },
    handleClearSearchGetData() {
      this.searchArr.order_id = "";
      this.searchArr.service_status = "";
      this.searchArr.consultant = "";
      this.searchArr.feature = null;
      this.searchArr.actual_reg_type = null;
      this.searchArr.operator = "";
      this.searchArr.platform = null;
      this.searchArr.park = null;
      this.pageOption.currentPage = 1;
      this.searchVisible = false;
      this.getPageDatas();
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.pageOption.currentPage = 1;
      this.getPageDatas();
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageDatas();
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_froms")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    this.getPageDatas();
  },
};
// <!-- @import '~styles/varibles.styl' -->
</script>

<style lang="stylus" scoped>
@import '~styles/vertical.styl'
[v-cloak]
  display: none;
.text-border
 border: 1px solid #dcdfe6
 border-radius: 5px
 line-height: 45px
 margin-bottom: .1rem
.border-line
  border: solid 1px red
.header-text
  font-size: 16px
  color: #4d84fe
.card-margin
  margin-bottom: .4rem
.count_style
  display: inherit
  overflow: hidden
  text-overflow: ellipsiss
  white-space: nowrap
.check-succ
  color: #67C23A
.setBadge >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.logout >>> .el-drawer__header
  font-size: .36rem
  font-weight: 400
  color: #4D84FE
.logout >>> .el-table__header th
  color: #333333
.logout >>> .el-timeline-item__node--normal
  left: 0
  background-color: #ECF4FF
.el-select, .el-cascader
  width: 100%
.logout
  marginLeft()
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.clearfix:before,
.clearfix:after
  display: table
  content: ""
.clearfix:after
  clear: both
.search-row .el-col
  margin-bottom: .2rem
.count
  padding-left: .2rem
  line-height: .56rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.tr
  text-align: right
.dot
  display: inline-block
  width: 0.1rem
  height: 0.1rem
  border-radius: 50%
  margin-right: 0.1rem
  top: 0
  left: -.2rem
  bottom: 0
  margin: auto
.mt-50
  margin-top: 1rem
.mt-10
  margin-top: .2rem
.mb-10
  margin-bottom: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .tabs-title
    color: #5789F4
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
.el-date-editor
  width: 100% !important
.ellipsis-link
  display: inline-block
  max-width: 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
.AIdrawer .drawer-title
  background-color: #ecf5ff
  padding: 10px
  color: #409EFF
</style>



// WEBPACK FOOTER //
// src/pages/customer/Logout.vue